import { Box, CircularProgress, Divider, Stack } from "@mui/material";

import { PlanningMode } from "@/common/components/appointments/plan-attendance/PlanAttendanceDialog.types";
import { CalendarNavigationButton } from "@/common/components/calendar/components/calendar-header/components/navigation/components/navigation-button/CalendarNavigationButton";
import { useTranslation } from "@/translations";

import { AttendanceDayPanel } from "../day-panel/AttendanceDayPanel";
import { PlanningModeSelect } from "../planning-mode-select/PlanningModeSelect";
import { useWeeklyPlanningForm } from "./hooks/useWeeklyPlanningForm";

type WeeklyPlanningFormResult = ReturnType<typeof useWeeklyPlanningForm>;

interface Props extends WeeklyPlanningFormResult {
  onModeChange: (mode: PlanningMode) => void;
}

export function WeeklyPlanningForm({
  formik,
  purposes,
  purposeOptions,
  navigateWeek,
  addEntry,
  removeEntry,
  updateDayEntries,
  isLoading,
  onModeChange,
}: Props) {
  const { t } = useTranslation();

  return (
    <Stack spacing={3} width={1200}>
      <Box display="flex" alignItems="center" gap={2} pt={1} height={48}>
        <PlanningModeSelect value={PlanningMode.Weekly} onChange={onModeChange} />
        <CalendarNavigationButton
          onPrevClick={() => void navigateWeek("prev")}
          onNextClick={() => void navigateWeek("next")}
          previousLabel={t("calendar.previousWeek")}
          nextLabel={t("calendar.nextWeek")}
        />
      </Box>
      <Divider />
      <Stack spacing={2}>
        {isLoading && formik.values.days.length === 0 && (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        )}
        {formik.values.days.map((dayValues, dayIndex) => (
          <AttendanceDayPanel
            key={dayIndex}
            formik={formik}
            dayIndex={dayIndex}
            dayValues={dayValues}
            purposeOptions={purposeOptions}
            purposes={purposes}
            onAddEntry={addEntry}
            onRemoveEntry={removeEntry}
            updateDayEntries={updateDayEntries}
          />
        ))}
      </Stack>
    </Stack>
  );
}
